import type { ReactNode } from 'react';
import {
    Car,
    Home,
    Tractor,
    Sun,
    Building2,
    Briefcase,
    Shield,
    Plane,
    FileCheck,
    Cpu,
    Handshake,
    HardHat,
} from 'lucide-react';
import { createElement } from 'react';

export interface ServiceItem {
    id: string;
    icon: ReactNode;
    title: string;
    description: string;
    category: 'auto' | 'property' | 'business' | 'personal';
}

export const services: ServiceItem[] = [
    {
        id: 'rca-casco',
        icon: createElement(Car, { className: 'w-8 h-8' }),
        title: 'RCA & CASCO',
        description: 'Asigurari auto: RCA, CASCO, CMR pentru toate tipurile de vehicule.',
        category: 'auto',
    },
    {
        id: 'pad-locuinte',
        icon: createElement(Home, { className: 'w-8 h-8' }),
        title: 'PAD & Locuinte',
        description: 'Asigurarea locuintelor (PAD-Obligatorie si Facultativa).',
        category: 'property',
    },
    {
        id: 'agricole',
        icon: createElement(Tractor, { className: 'w-8 h-8' }),
        title: 'Agricole',
        description: 'Asigurari agricole, inclusiv seceta, inghet timpuriu, inghet tarziu.',
        category: 'business',
    },
    {
        id: 'panouri-solare',
        icon: createElement(Sun, { className: 'w-8 h-8' }),
        title: 'Panouri Solare',
        description: 'Asigurarea panourilor solare si instalatiilor fotovoltaice.',
        category: 'property',
    },
    {
        id: 'constructii',
        icon: createElement(HardHat, { className: 'w-8 h-8' }),
        title: 'CAR Constructii',
        description: 'Asigurarea lucrarilor de constructii-montaj (CAR).',
        category: 'business',
    },
    {
        id: 'profesionala',
        icon: createElement(Briefcase, { className: 'w-8 h-8' }),
        title: 'Profesionala',
        description: 'Asigurari profesionale pentru avocati, notari, medici, contabili, etc.',
        category: 'business',
    },
    {
        id: 'raspundere',
        icon: createElement(Shield, { className: 'w-8 h-8' }),
        title: 'Raspundere Civila',
        description: 'Asigurari de raspundere civila pentru producatori, prestatori de servicii.',
        category: 'business',
    },
    {
        id: 'calatorii',
        icon: createElement(Plane, { className: 'w-8 h-8' }),
        title: 'Calatorii',
        description: 'Asigurari medicale pentru calatorii in strainatate, accidente, sanatate.',
        category: 'personal',
    },
    {
        id: 'cladiri',
        icon: createElement(Building2, { className: 'w-8 h-8' }),
        title: 'Cladiri & Bunuri',
        description: 'Asigurarea cladirilor si bunurilor (IF, PFA, Asociatii, PJ).',
        category: 'property',
    },
    {
        id: 'electronice',
        icon: createElement(Cpu, { className: 'w-8 h-8' }),
        title: 'Echipamente IT',
        description: 'Asigurari echipamente electronice, servere, drone, protectie cibernetica.',
        category: 'business',
    },
    {
        id: 'garantii',
        icon: createElement(Handshake, { className: 'w-8 h-8' }),
        title: 'Garantii',
        description: 'Asigurari de garantii: ARR, licitatii, buna executie, returnare avans.',
        category: 'business',
    },
    {
        id: 'transport',
        icon: createElement(FileCheck, { className: 'w-8 h-8' }),
        title: 'Transport',
        description: 'Asigurari de Bunuri si Persoane pe timpul transportului.',
        category: 'business',
    },
];

export interface AdditionalService {
    id: string;
    title: string;
    description: string;
    email?: string;
}

export const additionalServices: AdditionalService[] = [
    {
        id: 'asistenta',
        title: 'Asistenta gratuita',
        description:
            'pe toata durata valabilitatii politelor de asigurari (acte aditionale, instiintari/incasare rate, rezilieri).',
        email: 'doina.tomuleanu@renomia.ro',
    },
    {
        id: 'despagubiri',
        title: 'Obtinerea de despagubiri',
        description:
            'Asistenta in legatura cu obtinerea de despagubiri de la asiguratori si intocmirea dosarelor de dauna, inclusiv Carte Verde.',
        email: 'gheorghe.tomuleanu@renomia.ro',
    },
    {
        id: 'inspectii',
        title: 'Inspectii de risc',
        description: 'in vederea obtinerii ofertelor de asigurare de la asiguratori.',
        email: 'gheorghe.tomuleanu@renomia.ro',
    },
];
